import { BsWrenchAdjustable } from "react-icons/bs";
import { FiUsers, FiBarChart2, FiShield } from "react-icons/fi";
import { MdLocalShipping } from "react-icons/md";
import { RiMoneyDollarCircleLine, RiSteering2Line } from "react-icons/ri";
import { accessManagementIcon, fuelSidebarIcon, inventoryIcon, tripSidebarIcon, contractSidebarIcon } from "./svgs";
import { images } from "./images";
import moment from "moment/moment";
import {
  AppMainModules,
  CustomersSubModules,
  FinancePermission,
  FinanceSubModules,
  FMCRPermission,
  FMCRSubModules,
  FuelSubModules,
  OperationsSubModules,
  TripPermission,
  TripSubModules,
} from "./app-constant";

const driverSafetySidebarIcon = <RiSteering2Line fontSize={"24px"} />;
const customerSidebarIcon = <FiUsers fontSize={"24px"} />;
const financeSidebarIcon = <RiMoneyDollarCircleLine fontSize={"24px"} />;
const fmcrSidebarIcon = <FiBarChart2 fontSize={"24px"} />;

const buildFinancePermissions = () => [
  { id: "finance-create", name: "Create", slug: FinancePermission.Create },
  { id: "finance-update", name: "Update", slug: FinancePermission.Update },
  { id: "finance-delete", name: "Delete", slug: FinancePermission.Delete },
  { id: "finance-view", name: "View", slug: FinancePermission.View },
];

const buildTripPermissions = () => [
  { id: "trip-create", name: "Create", slug: TripPermission.Create },
  { id: "trip-update", name: "Update", slug: TripPermission.Update },
  { id: "trip-delete", name: "Delete", slug: TripPermission.Delete },
  { id: "trip-view", name: "View", slug: TripPermission.View },
  { id: "trip-created", name: "Created", slug: TripPermission.Created },
  { id: "trip-stops", name: "Trip Stops", slug: TripPermission.TripStops },
  { id: "trip-checklists-and-allocations", name: "Checklists and Allocations", slug: TripPermission.ChecklistsAndAllocations },
  { id: "trip-ready-to-dispatch", name: "Ready to Dispatch", slug: TripPermission.ReadyToDispatch },
  { id: "trip-in-transit", name: "In Transit", slug: TripPermission.InTransit },
  { id: "trip-correction", name: "Correction", slug: TripPermission.Correction },
  { id: "trip-unverified", name: "Unverified", slug: TripPermission.Unverified },
  { id: "trip-verified", name: "Verified", slug: TripPermission.Verified },
  { id: "trip-completed", name: "Completed", slug: TripPermission.Completed },
  { id: "trip-closed", name: "Closed", slug: TripPermission.Closed },
  { id: "trip-approved", name: "Approved", slug: TripPermission.Approved },
  { id: "trip-petty-cash-add", name: "Petty Cash Add", slug: TripPermission.PettyCashAdd },
  { id: "trip-petty-cash-view", name: "Petty Cash View", slug: TripPermission.PettyCashView },
  { id: "trip-petty-cash-edit", name: "Petty Cash Edit", slug: TripPermission.PettyCashEdit },
  { id: "trip-petty-cash-delete", name: "Petty Cash Delete", slug: TripPermission.PettyCashDelete },
  { id: "trip-petty-cash-status-update", name: "Petty Cash Approval Status", slug: TripPermission.PettyCashStatusUpdate },
  { id: "trip-petty-cash-export-pdf", name: "Petty Cash Export PDF", slug: TripPermission.PettyCashExportPdf },
  { id: "trip-petty-cash-export-excel", name: "Petty Cash Export Excel", slug: TripPermission.PettyCashExportExcel },
  { id: "trip-fuel-logs-add", name: "Fuel Logs Add", slug: TripPermission.FuelLogsAdd },
  { id: "trip-fuel-logs-view", name: "Fuel Logs View", slug: TripPermission.FuelLogsView },
  { id: "trip-fuel-logs-edit", name: "Fuel Logs Edit", slug: TripPermission.FuelLogsEdit },
  { id: "trip-fuel-logs-delete", name: "Fuel Logs Delete", slug: TripPermission.FuelLogsDelete },
  { id: "trip-expenses-add", name: "Expenses Add", slug: TripPermission.ExpensesAdd },
  { id: "trip-expenses-view", name: "Expenses View", slug: TripPermission.ExpensesView },
  { id: "trip-expenses-edit", name: "Expenses Edit", slug: TripPermission.ExpensesEdit },
  { id: "trip-expenses-delete", name: "Expenses Delete", slug: TripPermission.ExpensesDelete },
  { id: "trip-start", name: "Trip Start", slug: TripPermission.TripStart },
  { id: "trip-fuel-sheet", name: "Fuel Sheet", slug: TripPermission.FuelSheet },
  { id: "trip-builty", name: "Builty", slug: TripPermission.Builty },
  { id: "trip-pod", name: "POD", slug: TripPermission.POD },
];

const tripFallbackMenus = [
  {
    id: "trips",
    name: "Trips",
    slug: "/trips",
    url: "/trips",
  },
  {
    id: "trips-list",
    name: "Trips List",
    slug: "/trips-list",
    url: "/trips-list",
  },
];

const financeFallbackMenus = [
  {
    id: "finance-dashboard",
    name: "Dashboard",
    slug: "/finance-dashboard",
    url: "/finance-dashboard",
  },
  // {
  //   id: "finance-trip-cost-estimation",
  //   name: "Trip Cost Estimation",
  //   slug: `/${FinanceSubModules.TripCostEstimation}`,
  //   url: `/${FinanceSubModules.TripCostEstimation}`,
  // },
  // {
  //   id: "finance-driver-expense",
  //   name: "Driver Expense",
  //   slug: `/${FinanceSubModules.DriverExpense}`,
  //   url: `/${FinanceSubModules.DriverExpense}`,
  // },
  // {
  //   id: "finance-driver-payments",
  //   name: "Driver Payments",
  //   slug: `/${FinanceSubModules.DriverPayments}`,
  //   url: `/${FinanceSubModules.DriverPayments}`,
  // },
  {
    id: "finance-payroll",
    name: "Payroll",
    slug: `/${FinanceSubModules.Payroll}`,
    url: `/${FinanceSubModules.Payroll}`,
  },
  // {
  //   id: "finance-pricing-templates",
  //   name: "Contract",
  //   slug: `/${FinanceSubModules.PricingTemplates}`,
  //   url: `/${FinanceSubModules.PricingTemplates}`,
  // },
  {
    id: "finance-invoices",
    name: "Invoices",
    slug: `/${FinanceSubModules.Invoices}`,
    url: `/${FinanceSubModules.Invoices}`,
  },
  // {
  //   id: "finance-financial-reports",
  //   name: "Financial Reports",
  //   slug: `/${FinanceSubModules.FinancialReports}`,
  //   url: `/${FinanceSubModules.FinancialReports}`,
  // },
  {
    id: "finance-reports",
    name: "Reports",
    slug: "/finance-reports",
    url: "/finance-reports",
  },
  {
    id: "finance-settings",
    name: "Settings",
    slug: `/${FinanceSubModules.Settings}`,
    url: `/${FinanceSubModules.Settings}`,
  },
];

const buildFinanceModule = () => ({
  id: "finance-module",
  name: "Finance",
  slug: AppMainModules.finance,
  icon: financeSidebarIcon,
  menus: financeFallbackMenus.map((menu) => ({
    ...menu,
    permissions: buildFinancePermissions(),
  })),
});

export const normalizeSidebarSlug = (value) =>
  String(value || "")
    .trim()
    .replace(/^\/+/, "")
    .toLowerCase()
    .replace(/[&]/g, " ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const normalizePermissionSlug = (value) => normalizeSidebarSlug(value);
const ensureLeadingSlash = (value) => {
  const normalizedValue = String(value || "").trim().replace(/^\/+/, "");
  return normalizedValue ? `/${normalizedValue}` : "";
};

const MENU_ROUTE_ALIASES = {
  dashboard: "dashboard",
  services: "services",
  issue: "issue",
  "work-orders": "work-orders",
  categories: "categories",
  "vehicle-type": "vehicle-type",
  "part-models": "part-models",
  "part-makes": "part-makes",
  parts: "parts",
  procurement: "procurement",
  "vendor-warehouse": "vendor-&-warehouse",
  "vendor-and-warehouse": "vendor-&-warehouse",
  vendor: "vendor",
  warehouse: "warehouse",
  trips: "trips",
  "new-trips": "new-trips",
  newtrips: "new-trips",
  "trips-list": "trips-list",
  tripslist: "trips-list",
  "fuel-requests": "fuel-requests",
  "fuel-request": "fuel-requests",
  fuelrequests: "fuel-requests",
  fuelrequest: "fuel-requests",
  "trips/fuel-requests": "fuel-requests",
  "fuel/fuel-requests": "fuel-requests",
  "fuel-management/fuel-requests": "fuel-requests",
  fuel: "fuel",
  "fuel-stations": "fuel-stations",
  "driver-safety": "driver-safety",
  "driver-and-safety": "driver-safety",
  assets: "assets",
  finance: FinanceSubModules.TripCostEstimation,
  "finance-dashboard": "finance-dashboard",
  "finance/dashboard": "finance-dashboard",
  "trip-cost-estimation": FinanceSubModules.TripCostEstimation,
  "finance-trip-cost-estimation": FinanceSubModules.TripCostEstimation,
  expenses: FinanceSubModules.DriverExpense,
  "driver-expense": FinanceSubModules.DriverExpense,
  "driver-expenses": FinanceSubModules.DriverExpense,
  "finance-driver-expense": FinanceSubModules.DriverExpense,
  "driver-payments": FinanceSubModules.DriverPayments,
  "driver-payment": FinanceSubModules.DriverPayments,
  "finance-driver-payments": FinanceSubModules.DriverPayments,
  payroll: FinanceSubModules.Payroll,
  "finance-payroll": FinanceSubModules.Payroll,
  "pricing-templates": FinanceSubModules.PricingTemplates,
  "pricing-template": FinanceSubModules.PricingTemplates,
  "finance-pricing-templates": FinanceSubModules.PricingTemplates,
  contract: "contract",
  invoices: FinanceSubModules.Invoices,
  invoice: FinanceSubModules.Invoices,
  "finance-invoices": FinanceSubModules.Invoices,
  "financial-reports": "finance-reports",
  "finance-reports": "finance-reports",
  "finance/reports": "finance-reports",
  "financial-report": "finance-reports",
  "finance-financial-reports": "finance-reports",
  "finance-settings": FinanceSubModules.Settings,
  customers: "customers",
  cutomers: "customers",
  "3pl-customers": "customers",
  transporter: "transporters",
  transporters: "transporters",
  "3pl-transporter": "transporters",
  "load-booking": "3pl/load-booking",
  "3pl-load-booking": "3pl/load-booking",
  quotations: "3pl/quotations",
  "3pl-quotations": "3pl/quotations",
  "access-management": "access-management",
  users: "access-management",
  roles: "roles",
  "role-management": "role-management",
  "app-modules": "app-modules",
  fmcr: "fmcr",
  "vehicle-tracking": "fmcr/vehicle-tracking",
  "fmcr/vehicle-tracking": "fmcr/vehicle-tracking",
};

export const isSuperAdminRole = (role) => {
  if (!role) {
    try {
      const userDetails = JSON.parse(localStorage.getItem("fms-maintenance-details"));
      if (userDetails) {
        if (userDetails.is_super_admin === true || userDetails.is_superuser === true) return true;
        const uRole = userDetails.my_role || userDetails.role || userDetails.user_role;
        if (uRole) {
          const uSlug = String(uRole?.slug || uRole?.name || uRole?.role_name || (typeof uRole === "string" ? uRole : "")).trim().toLowerCase().replace(/[^a-z0-9]/g, "");
          if (uSlug === "superadmin" || uSlug === "super") return true;
        }
      }
    } catch (e) { }
    return false;
  }
  if (typeof role === "string") {
    const normalized = role.trim().toLowerCase().replace(/[^a-z0-9]/g, "");
    return normalized === "superadmin" || normalized === "super";
  }
  const slug = String(role?.slug || role?.name || role?.role_name || "").trim().toLowerCase().replace(/[^a-z0-9]/g, "");
  return slug === "superadmin" || slug === "super";
};

const resolveCanonicalModuleSlug = (value) => {
  const normalizedValue = normalizeSidebarSlug(value);

  if (!normalizedValue) return "";
  if (normalizedValue === "maintenance") return AppMainModules.maintenance;
  if (normalizedValue === "inventory-management") return AppMainModules.inventoryManagement;
  if (normalizedValue === "trip-management") return AppMainModules.tripManagement;
  if (["fuel-management", "fuel"].includes(normalizedValue)) return AppMainModules.fuelManagement;
  if (normalizedValue === "finance") return AppMainModules.finance;
  if (normalizedValue === "contract") return AppMainModules.contract;
  if (normalizedValue === "fmcr") return AppMainModules.fmcr;
  if (
    [
      "operations",
      "driver-safety",
      "driver-and-safety",
      "driver-safety-management",
    ].includes(normalizedValue)
  ) {
    return AppMainModules.operations;
  }
  if (["assets-management", "asset-management"].includes(normalizedValue)) {
    return AppMainModules.assetsManagement;
  }
  if (["customers", "cutomers", "customer"].includes(normalizedValue)) {
    return AppMainModules.customers;
  }
  if (
    [
      "access-management",
      "access",
      "user-management",
      "roles",
      "role-management",
      "app-modules",
    ].includes(normalizedValue)
  ) {
    return "access-management";
  }
  if (["3pl", "three-pl"].includes(normalizedValue)) {
    return "3pl";
  }
  if (["fmcr", "fleet-monitoring", "fleet-monitoring-control-room"].includes(normalizedValue)) {
    return AppMainModules.fmcr;
  }

  return normalizedValue;
};

export const resolveCanonicalMenuSlug = (value, parentModuleSlug = "") => {
  const normalizedValue = normalizeSidebarSlug(value);
  if (!normalizedValue) return "";

  const normalizedModSlug = normalizeSidebarSlug(parentModuleSlug);

  // Scoped to fmcr module
  if (normalizedModSlug === "fmcr" || normalizedModSlug === AppMainModules.fmcr) {
    if (["fmcr", "tracking", "reports", "fleet-monitoring"].includes(normalizedValue)) return "fmcr";
  }

  // Scoped to fuel-management module
  if (normalizedModSlug === "fuel-management" || normalizedModSlug === "fuel" || normalizedModSlug === AppMainModules.fuelManagement) {
    if (["fuel-requests", "fuel-request", "fuelrequests"].includes(normalizedValue)) return "fuel-requests";
    if (["fuel-stations", "fuel-station", "fuelstations"].includes(normalizedValue)) return "fuel-stations";
    if (["fuel", "fuel-logs"].includes(normalizedValue)) return "fuel";
  }

  // Scoped to trip-management module
  if (normalizedModSlug === "trip-management" || normalizedModSlug === "trip" || normalizedModSlug === "trips" || normalizedModSlug === AppMainModules.tripManagement) {
    if (["trips-list", "tripslist", "trip-list", "triplist", "trips-management", "trip-management", "list", "trip_list"].includes(normalizedValue)) return "trips-list";
    if (["trips", "trip"].includes(normalizedValue)) return "trips";
    if (["petty-cash", "pettycash"].includes(normalizedValue)) return "petty-cash";
    if (["trip-expenses", "trip-expense", "expenses", "expense", "tripexpenses", "tripexpense"].includes(normalizedValue)) return "trip-expenses";
  }

  // Scoped to finance module
  if (normalizedModSlug === "finance") {
    if (normalizedValue === "dashboard" || normalizedValue === "finance-dashboard") return "finance-dashboard";
    if (normalizedValue === "reports" || normalizedValue === "finance-reports" || normalizedValue === "financial-reports") return "finance-reports";
    if (normalizedValue === "settings" || normalizedValue === "finance-settings") return "finance-settings";
    if (normalizedValue === "trip-cost-estimation") return "trip-cost-estimation";
    if (normalizedValue === "expenses" || normalizedValue === "driver-expense" || normalizedValue === "driver-expenses") return "expenses";
    if (normalizedValue === "driver-payments" || normalizedValue === "driver-payment") return "driver-payments";
    if (normalizedValue === "payroll") return "payroll";
    if (normalizedValue === "invoices" || normalizedValue === "invoice") return "invoices";
  }

  // Scoped to maintenance module
  if (normalizedModSlug === "maintenance") {
    if (normalizedValue === "dashboard") return "dashboard";
    if (normalizedValue === "services") return "services";
    if (normalizedValue === "work-orders") return "work-orders";
    if (normalizedValue === "issue" || normalizedValue === "issues") return "issue";
    if (normalizedValue === "categories") return "categories";
    if (normalizedValue === "vehicle-type") return "vehicle-type";
    if (normalizedValue === "part-models") return "part-models";
    if (normalizedValue === "part-makes") return "part-makes";
  }

  // Scoped to access management module
  if (normalizedModSlug === "access-management") {
    if (normalizedValue === "users" || normalizedValue === "access-management" || normalizedValue === "access") return "access-management";
    if (normalizedValue === "role-management") return "role-management";
    if (normalizedValue === "roles") return "roles";
    if (normalizedValue === "app-modules") return "app-modules";
  }

  return MENU_ROUTE_ALIASES[normalizedValue] || normalizedValue;
};

const normalizePermissionEntry = (permission = {}) => ({
  ...permission,
  slug: normalizePermissionSlug(permission?.slug || permission?.name),
});

const normalizeMenuEntry = (menu = {}, parentModuleSlug = "") => {
  const resolvedMenuSlug = resolveCanonicalMenuSlug(menu?.slug || menu?.url || menu?.name, parentModuleSlug);

  return {
    ...menu,
    slug: ensureLeadingSlash(resolvedMenuSlug),
    url: ensureLeadingSlash(resolvedMenuSlug),
    permissions: Array.isArray(menu?.permissions)
      ? menu.permissions.map(normalizePermissionEntry)
      : [],
  };
};

const normalizeModuleEntry = (module = {}) => {
  const modSlug = resolveCanonicalModuleSlug(module?.slug || module?.name);
  return {
    ...module,
    slug: modSlug,
    menus: Array.isArray(module?.menus)
      ? module.menus.map((menu) => normalizeMenuEntry(menu, modSlug))
      : [],
  };
};

const buildCustomerModuleFromMenu = (customerMenu, sourceModule) => ({
  id: `customers-${sourceModule?.id || "module"}`,
  name: "Customers",
  slug: AppMainModules.customers,
  icon: customerSidebarIcon,
  menus: [
    {
      ...customerMenu,
      name: customerMenu?.name || "Customers",
      slug: "/customers",
      url: "/customers",
    },
  ],
});

export const permissionsMatch = (permissions = [], targetPermission) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("fms-maintenance-details"));
    if (isSuperAdminRole(userDetails?.my_role)) {
      return true;
    }
  } catch (e) { }

  if (!permissions || !permissions.length) return false;

  // Filter out permissions that are explicitly disabled (selected_permission === false)
  const isPermissionActive = (p) => {
    if (!p) return false;
    if (typeof p === "string") return Boolean(p.trim());
    if (typeof p === "object") {
      if ("selected_permission" in p) {
        const val = p.selected_permission;
        if (val === false || val === 0 || val === "false" || val === "0" || val === null || val === undefined) {
          return false;
        }
        return Boolean(val);
      }
      if ("is_selected" in p) {
        const val = p.is_selected;
        if (val === false || val === 0 || val === "false" || val === "0" || val === null || val === undefined) {
          return false;
        }
        return Boolean(val);
      }
      if ("selected" in p) {
        const val = p.selected;
        if (val === false || val === 0 || val === "false" || val === "0" || val === null || val === undefined) {
          return false;
        }
        return Boolean(val);
      }
      if ("has_permission" in p) {
        const val = p.has_permission;
        if (val === false || val === 0 || val === "false" || val === "0" || val === null || val === undefined) {
          return false;
        }
        return Boolean(val);
      }
      return true;
    }
    return Boolean(p);
  };

  const validPermissions = permissions.filter(isPermissionActive);

  if (!validPermissions.length) return false;

  if (targetPermission === "any") {
    return validPermissions.length > 0;
  }

  const normalizedTargets = (Array.isArray(targetPermission)
    ? targetPermission
    : [targetPermission]
  )
    .map(normalizePermissionSlug)
    .filter(Boolean);

  if (!normalizedTargets.length) return false;

  return validPermissions.some((permission) => {
    const permSlug = normalizePermissionSlug(permission?.slug);
    const permName = normalizePermissionSlug(permission?.name);
    const candidates = [permSlug, permName].filter(Boolean);

    return candidates.some((candidate) => {
      // 1. Direct exact match
      if (normalizedTargets.includes(candidate)) return true;

      // 2. Specific matching
      return normalizedTargets.some((target) => {
        if (target === "any") return true;

        if (target === "create") {
          return candidate === "create" || candidate === "create-trip" || candidate === "trip-create" || (candidate.startsWith("create-") && candidate !== "created");
        }

        if (
          target === "created" ||
          target === "trip-planning" ||
          target === "planning" ||
          target === "trip-created" ||
          target === "trip_planning" ||
          target === "trip_created"
        ) {
          return (
            candidate === "created" ||
            candidate === "trip-planning" ||
            candidate === "planning" ||
            candidate === "trip-created" ||
            candidate === "trip_planning" ||
            candidate === "trip_created" ||
            candidate === "trip-create" ||
            candidate === "create" ||
            candidate === "create-trip" ||
            candidate === "trip-stage-created" ||
            candidate === "trip-stage-planning" ||
            candidate.includes("planning") ||
            candidate.includes("created")
          );
        }

        if (target === "view") {
          return (
            candidate === "view" ||
            candidate === "view-trip" ||
            candidate === "trip-view" ||
            candidate === "trips-view" ||
            candidate === "view-tracking" ||
            candidate === "view-report" ||
            candidate === "tracking" ||
            candidate === "reports" ||
            candidate.startsWith("view-") ||
            candidate.endsWith("-view") ||
            candidate.includes("view")
          );
        }

        if (target === "update") {
          return candidate === "update" || candidate === "edit" || candidate === "trip-update" || candidate === "update-trip";
        }

        if (target === "delete") {
          return candidate === "delete" || candidate === "trip-delete" || candidate === "delete-trip";
        }

        if (target === "verify" || target === "trip-verify" || target === "trip_verify") {
          return (
            candidate === "verify" ||
            candidate === "trip-verify" ||
            candidate === "trip_verify"
          );
        }

        if (target === "verified" || target === "trip-verified" || target === "trip_verified") {
          return (
            candidate === "verified" ||
            candidate === "trip-verified" ||
            candidate === "trip_verified"
          );
        }

        if (target === "approved" || target === "approve" || target === "trip-approved" || target === "trip_approved") {
          return (
            candidate === "approved" ||
            candidate === "approve" ||
            candidate === "trip-approved" ||
            candidate === "trip_approved" ||
            candidate === "trip-approve" ||
            candidate === "trip_approve"
          );
        }

        if (target === "unverified" || target === "trip-unverified" || target === "trip_unverified") {
          return (
            candidate === "unverified" ||
            candidate === "trip-unverified" ||
            candidate === "trip_unverified"
          );
        }

        if (
          target === "return-to-correction" ||
          target === "return_to_correction" ||
          target === "correction" ||
          target === "trip-correction" ||
          target === "trip_correction"
        ) {
          return (
            candidate === "return-to-correction" ||
            candidate === "return_to_correction" ||
            candidate === "correction" ||
            candidate === "trip-correction" ||
            candidate === "trip_correction"
          );
        }

        if (target === "trip-start" || target === "trip_start" || target === "start-trip") {
          return (
            candidate === "trip-start" ||
            candidate === "trip_start" ||
            candidate === "start-trip" ||
            candidate === "tripstart" ||
            candidate.includes("start")
          );
        }

        if (
          target === "petty-cash-approval-status" ||
          target === "petty_cash_approval_status" ||
          target === "pettycashapprovalstatus" ||
          target === "status-update" ||
          target === "status_update" ||
          target === "statusupdate" ||
          target === "petty-cash-status-update" ||
          target === "petty_cash_status_update"
        ) {
          return (
            candidate === "petty-cash-approval-status" ||
            candidate === "petty_cash_approval_status" ||
            candidate === "pettycashapprovalstatus" ||
            candidate === "status-update" ||
            candidate === "status_update" ||
            candidate === "statusupdate" ||
            candidate === "petty-cash-status-update" ||
            candidate === "petty_cash_status_update" ||
            candidate.includes("approval-status")
          );
        }

        if (
          target === "fuel-request-approval-status" ||
          target === "fuel_request_status_update" ||
          target === "fuelrequeststatusupdate"
        ) {
          return (
            candidate === "fuel-request-approval-status" ||
            candidate === "fuel_request_status_update" ||
            candidate === "fuelrequeststatusupdate" ||
            candidate === "fuel-status-update" ||
            candidate === "fuel_status_update"
          );
        }

        if (
          target === "trip-expense-export-pdf" ||
          target === "trip_expense_export_pdf" ||
          target === "expenses-export-pdf" ||
          target === "export-pdf"
        ) {
          return (
            candidate === "trip-expense-export-pdf" ||
            candidate === "trip_expense_export_pdf" ||
            candidate === "expenses-export-pdf" ||
            candidate === "export-pdf" ||
            (candidate.includes("expense") && candidate.includes("pdf"))
          );
        }

        if (
          target === "trip-expense-export-excel" ||
          target === "trip_expense_export_excel" ||
          target === "expenses-export-excel" ||
          target === "export-excel"
        ) {
          return (
            candidate === "trip-expense-export-excel" ||
            candidate === "trip_expense_export_excel" ||
            candidate === "expenses-export-excel" ||
            candidate === "export-excel" ||
            (candidate.includes("expense") && (candidate.includes("excel") || candidate.includes("xlsx")))
          );
        }

        if (candidate === target) return true;

        // Clean comparison without dashes/underscores/spaces (e.g. "fuel_logs-add" vs "fuel-logs-add")
        const targetClean = target.replace(/[-_\s]+/g, "");
        const candidateClean = candidate.replace(/[-_\s]+/g, "");
        if (targetClean && targetClean === candidateClean) return true;

        return false;
      });
    });
  });
};

const resolveStoredSidebar = (userSidebar = []) => {
  const normalizedSidebar = Array.isArray(userSidebar)
    ? userSidebar.map(normalizeModuleEntry)
    : [];
  const hasStandaloneCustomersModule = normalizedSidebar.some(
    (module) => resolveCanonicalModuleSlug(module?.slug || module?.name) === AppMainModules.customers
  );

  return normalizedSidebar.flatMap((module) => {
    if (module?.slug !== "3pl") {
      return [module];
    }

    const moduleMenus = Array.isArray(module?.menus) ? module.menus : [];
    const customerMenu = moduleMenus.find(
      (menu) => resolveCanonicalMenuSlug(menu?.slug || menu?.url || menu?.name) === CustomersSubModules.Customers
    );
    const remainingMenus = moduleMenus.filter(
      (menu) => resolveCanonicalMenuSlug(menu?.slug || menu?.url || menu?.name) !== CustomersSubModules.Customers
    );

    const nextModules = [];
    if (customerMenu && !hasStandaloneCustomersModule) {
      nextModules.push(buildCustomerModuleFromMenu(customerMenu, module));
    }

    if (remainingMenus.length) {
      nextModules.push({
        ...module,
        menus: remainingMenus,
      });
    }

    return nextModules;
  });
};

export const getResolvedUserSidebar = (userSidebar = []) => {
  return resolveStoredSidebar(userSidebar).map((module) => {
    if (module?.slug === AppMainModules.operations) {
      return {
        ...module,
        icon: module?.icon || driverSafetySidebarIcon,
      };
    }

    if (module?.slug === AppMainModules.customers) {
      return {
        ...module,
        icon: module?.icon || customerSidebarIcon,
      };
    }

    if (module?.slug === AppMainModules.finance) {
      return {
        ...module,
        icon: module?.icon || financeSidebarIcon,
      };
    }

    if (module?.slug === AppMainModules.contract) {
      return {
        ...module,
        icon: module?.icon || contractSidebarIcon,
      };
    }

    if (module?.slug === "access-management") {
      return {
        ...module,
        icon: module?.icon || accessManagementIcon,
      };
    }

    return module;
  });
};

/**
 * Check if user has a specific permission for a menu within a module
 * @param {string} menuSlug - The menu/section slug
 * @param {string} permissionSlug - The permission slug to check
 * @param {string} moduleSlug - The module slug (defaults to 'maintenance')
 * @returns {boolean} - Whether user has the permission
 */
export const maintenance = (menuSlug, permissionSlug, moduleSlug = 'maintenance') => {
  // Support object signature: { permissionSlug, menuSlug, moduleSlug }
  let targetMenu, targetPerm, targetModuleSlugArg;

  if (typeof menuSlug === 'object' && menuSlug !== null) {
    targetMenu = menuSlug.menuSlug;
    targetPerm = menuSlug.permissionSlug;
    targetModuleSlugArg = menuSlug.moduleSlug || 'maintenance';
  } else {
    targetMenu = menuSlug;
    targetPerm = permissionSlug;
    targetModuleSlugArg = moduleSlug;
  }

  const userDetails = JSON.parse(localStorage.getItem("fms-maintenance-details"));

  // Super admin always has access
  if (isSuperAdminRole(userDetails?.my_role)) {
    return true;
  }

  // If no user details or sidebar, deny access
  const resolvedSidebar = getResolvedUserSidebar(userDetails?.user_sidebar);

  if (!userDetails || resolvedSidebar.length === 0) {
    return false;
  }

  // Normalize slugs
  const targetMenuSlug = resolveCanonicalMenuSlug(targetMenu, targetModuleSlugArg);
  const targetModuleSlug = resolveCanonicalModuleSlug(targetModuleSlugArg);

  // Find the specific module across all modules
  const targetModule = resolvedSidebar.find(module => {
    const currentModSlug = resolveCanonicalModuleSlug(module?.slug || module?.name);
    return currentModSlug === targetModuleSlug ||
      (targetModuleSlug === AppMainModules.tripManagement && (currentModSlug === "trip-management" || currentModSlug === "trips" || currentModSlug === "trip")) ||
      (targetModuleSlug === AppMainModules.fuelManagement && (currentModSlug === "fuel-management" || currentModSlug === "fuel"));
  });

  if (!targetModule) {
    return false;
  }

  if (targetPerm === "any" || (Array.isArray(targetPerm) && targetPerm.includes("any"))) {
    return true;
  }

  // Find the specific menu in that module
  const menuItem = (targetModule.menus || []).find(menu => {
    const currentSlug = resolveCanonicalMenuSlug(menu?.slug || menu?.url || menu?.name, targetModuleSlug);
    if (targetModuleSlug === AppMainModules.tripManagement) {
      if (targetMenuSlug === "petty-cash") {
        return currentSlug === "petty-cash" || currentSlug === "pettycash";
      }
      if (targetMenuSlug === "trip-expenses" || targetMenuSlug === "trip-expense" || targetMenuSlug === "expenses") {
        return currentSlug === "trip-expenses" || currentSlug === "trip-expense" || currentSlug === "expenses" || currentSlug === "tripexpenses";
      }
      if (targetMenuSlug === "trips-list") {
        return currentSlug === "trips-list" || currentSlug === "trips" || currentSlug === "trip-management" || currentSlug === "trip";
      }
      if (targetMenuSlug === "trips") {
        return currentSlug === "trips" || currentSlug === "trips-list" || currentSlug === "trip-management" || currentSlug === "trip";
      }
    }
    return currentSlug === targetMenuSlug;
  });

  // Check if user has the required permission for this menu
  if (menuItem) {
    return permissionsMatch(menuItem.permissions, targetPerm);
  }

  // Check module-level permissions as fallback ONLY if the module has no menus defined at all
  if ((!targetModule.menus || targetModule.menus.length === 0) && targetModule.permissions) {
    return permissionsMatch(targetModule.permissions, targetPerm);
  }

  return false;
};

// Aliasing for backward compatibility
export const hasPermission = maintenance;

export const hasTripPermission = (permissionSlug, menuSlug = "trips") => {
  if (isSuperAdminRole()) return true;

  const targetMenu = menuSlug === "trips-list" ? "trips-list" : "trips";
  return hasPermission({
    permissionSlug,
    menuSlug: targetMenu,
    moduleSlug: AppMainModules.tripManagement,
  });
};

export const hasFuelRequestPermission = (permissionSlug) => {
  if (isSuperAdminRole()) return true;

  return (
    hasPermission({
      permissionSlug,
      menuSlug: FuelSubModules.FuelRequests,
      moduleSlug: AppMainModules.fuelManagement,
    }) ||
    hasPermission({
      permissionSlug,
      menuSlug: TripSubModules.FuelRequests,
      moduleSlug: AppMainModules.tripManagement,
    })
  );
};

export const hasPettyCashPermission = (permissionSlug) => {
  if (isSuperAdminRole()) return true;

  return hasPermission({
    permissionSlug,
    menuSlug: TripSubModules.PettyCash,
    moduleSlug: AppMainModules.tripManagement,
  });
};

export const hasTripExpensePermission = (permissionSlug = "any") => {
  if (isSuperAdminRole()) return true;

  return hasFullPermission({
    permissionSlug,
    menuSlug: TripSubModules.TripExpense,
    moduleSlug: AppMainModules.tripManagement,
  });
};

export const canExportTripExpensePdf = () =>
  isSuperAdminRole() ||
  hasTripExpensePermission("trip-expense-export-pdf") ||
  hasTripExpensePermission("export-pdf") ||
  hasTripPermission(TripPermission.TripExpenseExportPdf);

export const canExportTripExpenseExcel = () =>
  isSuperAdminRole() ||
  hasTripExpensePermission("trip-expense-export-excel") ||
  hasTripExpensePermission("export-excel") ||
  hasTripPermission(TripPermission.TripExpenseExportExcel);

export const canViewTripRouteJourney = () => hasTripPermission(TripPermission.TripStops);

export const hasFullPermission = ({ permissionSlug, menuSlug, moduleSlug = 'maintenance' }) => {
  const userDetails = JSON.parse(localStorage.getItem("fms-maintenance-details"));

  // Super admin always has access
  if (isSuperAdminRole(userDetails?.my_role)) {
    return true;
  }

  // If no user details or sidebar, deny access
  const resolvedSidebar = getResolvedUserSidebar(userDetails?.user_sidebar);

  if (!userDetails || resolvedSidebar.length === 0) {
    return false;
  }

  // Normalize slugs
  const targetMenuSlug = resolveCanonicalMenuSlug(menuSlug, moduleSlug);
  const targetModuleSlug = resolveCanonicalModuleSlug(moduleSlug);

  // Find the specific module across all modules
  let targetModule = resolvedSidebar.find(module => {
    const currentModSlug = resolveCanonicalModuleSlug(module?.slug || module?.name);
    return currentModSlug === targetModuleSlug ||
      (targetModuleSlug === AppMainModules.tripManagement && (currentModSlug === "trip-management" || currentModSlug === "trips" || currentModSlug === "trip")) ||
      (targetModuleSlug === AppMainModules.fuelManagement && (currentModSlug === "fuel-management" || currentModSlug === "fuel"));
  });

  // If fuel-requests permission is searched, allow finding it under fuelManagement or tripManagement
  if (!targetModule && targetMenuSlug === "fuel-requests") {
    const fallbackModuleSlug = targetModuleSlug === AppMainModules.fuelManagement ? AppMainModules.tripManagement : AppMainModules.fuelManagement;
    targetModule = resolvedSidebar.find(module => {
      const currentModSlug = resolveCanonicalModuleSlug(module?.slug || module?.name);
      return currentModSlug === fallbackModuleSlug ||
        (fallbackModuleSlug === AppMainModules.tripManagement && (currentModSlug === "trip-management" || currentModSlug === "trips" || currentModSlug === "trip")) ||
        (fallbackModuleSlug === AppMainModules.fuelManagement && (currentModSlug === "fuel-management" || currentModSlug === "fuel"));
    });
  }

  if (!targetModule) {
    return false;
  }

  // NOTE: "any" is intentionally NOT short-circuited here. It must be checked
  // per-menu (via permissionsMatch below) once the specific submenu is found -
  // otherwise having ANY permission anywhere in this module (e.g. Trip
  // Management) would grant "any" access to EVERY submenu under it (e.g.
  // Fuel Request, Petty Cash), even ones the role was never given.

  const moduleMenus = Array.isArray(targetModule.menus) ? targetModule.menus : [];

  // Find the specific menu in that module
  let menuItem = moduleMenus.find(menu => {
    const currentSlug = resolveCanonicalMenuSlug(menu?.slug || menu?.url || menu?.name, moduleSlug);
    if (targetModuleSlug === AppMainModules.tripManagement) {
      if (targetMenuSlug === "petty-cash") {
        return currentSlug === "petty-cash" || currentSlug === "pettycash";
      }
      if (targetMenuSlug === "trip-expenses" || targetMenuSlug === "trip-expense" || targetMenuSlug === "expenses") {
        return currentSlug === "trip-expenses" || currentSlug === "trip-expense" || currentSlug === "expenses" || currentSlug === "tripexpenses";
      }
      if (targetMenuSlug === "trips-list") {
        return currentSlug === "trips-list" || currentSlug === "trips" || currentSlug === "trip-management" || currentSlug === "trip";
      }
      if (targetMenuSlug === "trips") {
        return currentSlug === "trips" || currentSlug === "trips-list" || currentSlug === "trip-management" || currentSlug === "trip";
      }
    }
    if (targetMenuSlug === "fuel-requests") {
      return currentSlug === "fuel-requests" || currentSlug === "fuel-request";
    }
    return currentSlug === targetMenuSlug;
  });

  // Fallback for fuel-requests across any module in resolvedSidebar
  if (!menuItem && targetMenuSlug === "fuel-requests") {
    for (const mod of resolvedSidebar) {
      const menus = Array.isArray(mod?.menus) ? mod.menus : [];
      const found = menus.find(m => {
        const cs = resolveCanonicalMenuSlug(m?.slug || m?.url || m?.name, mod?.slug);
        return cs === "fuel-requests" || cs === "fuel-request";
      });
      if (found) {
        menuItem = found;
        break;
      }
    }
  }

  // FMCR is a single-page module: the backend may nest its permissions under a
  // sub-menu whose slug/name doesn't literally resolve to "fmcr", or it may
  // attach them directly on the module with no sub-menu at all. Fall back
  // sensibly instead of silently denying access when the exact slug can't be
  // matched. Scoped to the fmcr module only so no other module is affected.
  if (!menuItem && targetModuleSlug === AppMainModules.fmcr) {
    if (moduleMenus.length === 1) {
      menuItem = moduleMenus[0];
    } else if (moduleMenus.length === 0 && Array.isArray(targetModule.permissions)) {
      menuItem = targetModule;
    }
  }

  // Check if user has the required permission for this menu
  if (menuItem) {
    return permissionsMatch(menuItem.permissions, permissionSlug);
  }

  // Check module-level permissions as fallback ONLY if the module has no menus defined at all
  if ((!targetModule.menus || targetModule.menus.length === 0) && targetModule.permissions) {
    return permissionsMatch(targetModule.permissions, permissionSlug);
  }

  return false;
};

/**
 * Check if the user has permission to access a specific trip stage.
 * Used when user clicks on a Trip ID in Trips List table or mobile cards.
 * @param {string} stage - The stage of the trip (e.g. 'created', 'trip-stops', 'checklists-and-allocations', 'in_transit', 'correction', 'unverified', 'verified', 'completed', 'closed')
 * @returns {{ allowed: boolean, stageDisplay: string, requiredPermission: string }}
 */
export const checkTripStagePermission = (stage) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("fms-maintenance-details"));
    if (isSuperAdminRole(userDetails?.my_role)) {
      return { allowed: true, stageDisplay: String(stage || 'Trip'), requiredPermission: "" };
    }

    const normalizedStage = String(stage || '').trim().toLowerCase().replace(/[\s_]+/g, '-');

    let targetPermissions = [];
    let stageDisplay = "";

    switch (normalizedStage) {
      case 'created':
      case 'planned':
      case 'planning':
      case 'trip-planning':
      case 'trip_planning':
      case 'trip-created':
      case 'trip_created':
        stageDisplay = "Trip Planning";
        targetPermissions = [
          'created',
          'trip-planning',
          'planning',
          'trip-created',
          'trip_planning',
          'trip_created',
          'create',
          'view',
        ];
        break;

      case 'trip-stops':
      case 'trip-stop':
      case 'trip_stops':
        stageDisplay = "Loading & Dispatch";
        targetPermissions = ['trip-stops', 'trip_stops', 'trip-stop'];
        break;

      case 'checklists-and-allocations':
      case 'checklists_and_allocations':
      case 'checklist':
      case 'checklists':
      case 'allocations':
      case 'loading-dispatch':
      case 'loading':
        stageDisplay = "Ready to Dispatch";
        targetPermissions = ['checklists-and-allocations', 'checklists_and_allocations'];
        break;

      case 'ready-dispatch':
      case 'ready-to-dispatch':
      case 'ready_to_dispatch':
        stageDisplay = "Ready to Dispatch";
        targetPermissions = ['ready-to-dispatch', 'ready_to_dispatch'];
        break;

      case 'in-transit':
      case 'intransit':
      case 'moving':
        stageDisplay = "In Transit";
        targetPermissions = ['in-transit', 'in_transit', 'intransit'];
        break;

      case 'correction':
        stageDisplay = "Correction";
        targetPermissions = ['correction'];
        break;

      case 'unverified':
        stageDisplay = "Verification Summary";
        targetPermissions = ['unverified'];
        break;

      case 'verified':
        stageDisplay = "Approval Summary";
        targetPermissions = ['verified'];
        break;

      case 'completed':
      case 'driver-completed':
      case 'driver_completed':
        stageDisplay = "Trip Completed";
        targetPermissions = ['completed', 'driver-completed', 'driver_completed'];
        break;

      case 'closed':
        stageDisplay = "Invoicing";
        targetPermissions = ['closed'];
        break;

      case 'approved':
        stageDisplay = "Approved";
        targetPermissions = ['approved'];
        break;

      default:
        stageDisplay = stage || "Trip Details";
        targetPermissions = [normalizedStage, 'view'];
        break;
    }

    const hasAccess = hasTripPermission(targetPermissions);

    return {
      allowed: Boolean(hasAccess),
      stageDisplay,
      requiredPermission: targetPermissions[0]
    };
  } catch (error) {
    console.error("Error checking trip stage permission:", error);
    return { allowed: false, stageDisplay: String(stage), requiredPermission: "" };
  }
};

// Chronological order of trip stages, matching TripsStageEnum's own declaration order.
const TRIP_STAGE_ORDER = [
  'created',
  'trip-stops',
  'checklists-and-allocations',
  'in-transit',
  'unverified',
  'correction',
  'verified',
  'closed',
  'completed',
];

const normalizeTripStageValue = (value) =>
  String(value || '').trim().toLowerCase().replace(/[\s_]+/g, '-');

/**
 * Whether a trip's current stage has reached (or passed) a given target stage,
 * per the fixed lifecycle order in TRIP_STAGE_ORDER. Used to lock editing on
 * earlier-stage pages (e.g. Trip Stops, Loading & Dispatch) once the trip has
 * moved on to In Transit or beyond, while still allowing read-only back-navigation.
 * @param {string} currentStage - The trip's current stage (e.g. detailData.stage)
 * @param {string} targetStage - The stage to compare against (e.g. 'in_transit')
 * @returns {boolean}
 */
export const hasTripReachedStage = (currentStage, targetStage) => {
  const currentIndex = TRIP_STAGE_ORDER.indexOf(normalizeTripStageValue(currentStage));
  const targetIndex = TRIP_STAGE_ORDER.indexOf(normalizeTripStageValue(targetStage));
  if (currentIndex === -1 || targetIndex === -1) return false;
  return currentIndex >= targetIndex;
};



/**
 * Format date to Month DD, YYYY format
 * @param {string} dateString - The date string to format
 * @returns {string} - Formatted date string
 */
export const dateMonthYear = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);

  // Check if date is valid
  if (isNaN(date.getTime())) return '';

  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };

  return date.toLocaleDateString('en-US', options);
};

export function formatDate(dateStr) {
  if (!dateStr) return "N/A";
  const m = getApiUtcMoment(dateStr);
  return m.isValid() ? m.format('DD-MMM-YYYY hh:mm A') : "N/A";
}

export function formatOnlyDate(dateStr) {
  if (!dateStr) return "N/A";
  const m = getApiUtcMoment(dateStr);
  return m.isValid() ? m.format('DD-MMM-YYYY') : "N/A";
}

export function formatDateTimeForInput(dateStr) {
  if (!dateStr) return "";
  const m = moment(dateStr);
  return m.isValid() ? m.format("YYYY-MM-DDTHH:mm") : "";
}

export function formatDateTimeForApi(dateStr) {
  if (!dateStr) return undefined;
  const m = moment(dateStr);
  return m.isValid() ? m.format("YYYY-MM-DDTHH:mm:ss") : undefined;
}

const normalizeApiDateTimeValue = (dateStr) => String(dateStr || "").trim().replace(" ", "T");

const getApiUtcMoment = (dateStr) => {
  if (!dateStr) return moment.invalid();
  const normalizedValue = normalizeApiDateTimeValue(dateStr);
  return moment(normalizedValue);
};

export function formatUtcDateTimeForInput(dateStr) {
  const m = getApiUtcMoment(dateStr);
  return m.isValid() ? m.format("YYYY-MM-DDTHH:mm") : "";
}

export function formatUtcDateTimeForApi(dateStr) {
  if (!dateStr) return null;
  const m = moment(dateStr);
  return m.isValid() ? m.format("YYYY-MM-DD HH:mm:ss") : null;
}

export function formatUtcDateTimeForDisplay(dateStr) {
  const m = getApiUtcMoment(dateStr);
  return m.isValid() ? m.format("DD-MMM-YYYY hh:mm A") : "N/A";
}

export function formatLocalDateTime(dateStr) {
  if (!dateStr) return "N/A";
  const m = moment(dateStr);
  return m.isValid() ? m.format("DD-MMM-YYYY hh:mm A") : "N/A";
}

export function getCurrentDateTimeInputValue() {
  return moment().format("YYYY-MM-DDTHH:mm");
}

export function hasDateTimePassed(dateStr) {
  if (!dateStr) return false;
  const m = moment(dateStr);
  return m.isValid() ? moment().isSameOrAfter(m) : false;
}

export const convertDateToInputFormat = (
  distanceInput,
  coveredDistanceInput
) => {
  const distance = parseFloat(distanceInput);
  const coveredDistance = parseFloat(coveredDistanceInput ?? 0);

  const percentage = (coveredDistance / distance) * 100;
  return percentage.toFixed(2);
};


export const formats = [
  "bold",
  "italic",
  "underline",
  "list",
  "bullet",
  "link",
];



const isSubModuleShow = String(process.env.REACT_APP_IS_APP_MODULE_SHOW).trim() === "true";

const baseSideMenuList = [
  {
    id: 1,
    heading: "Assets Management",
    url: null,
    icon: inventoryIcon,
    isDropdown: true,
    subMenusList: [
      {
        id: 1,
        name: "Assets",
        url: "/assets",
      }
    ]
  },
  {
    id: 2,
    heading: "Trip Management",
    url: null,
    icon: tripSidebarIcon,
    isDropdown: true,
    subMenusList: [
      {
        id: 1,
        name: "Trips",
        url: "/trips",
      },
      {
        id: 2,
        name: "Petty Cash",
        url: "/trips/petty-cash",
      },
      {
        id: 3,
        name: "Trip Expense",
        url: "/trips/expenses",
      }
    ]
  },
  {
    id: 13,
    heading: "FMCR",
    url: null,
    icon: fmcrSidebarIcon,
    isDropdown: true,
    subMenusList: [
      {
        id: 3,
        name: "Vehicle Tracking",
        url: "/fmcr/vehicle-tracking",
      },
    ],
  },
  {
    id: 3,
    heading: "Drivers",
    url: `/${OperationsSubModules.DriverSafety}`,
    icon: driverSafetySidebarIcon,
    isDropdown: false,
  },
  {
    id: 4,
    heading: "Fuel Management",
    url: null,
    icon: fuelSidebarIcon,
    isDropdown: true,
    subMenusList: [
      {
        id: 1,
        name: "Fuel",
        url: "/fuel",
      },
      {
        id: 2,
        name: "Fuel Stations",
        url: "/fuel-stations",
      },
      {
        id: 3,
        name: "Fuel Requests",
        url: "/fuel-requests",
      },
    ]
  },
  {
    id: 5,
    heading: "Inventory Management",
    url: null,
    icon: inventoryIcon,
    isDropdown: true,
    subMenusList: [
      {
        id: 1,
        name: "Parts",
        url: "/parts",
      },
      {
        id: 2,
        name: "Procurement",
        url: "/procurement",
      },
      {
        id: 3,
        name: "Vendor",
        url: "/vendor",
      },
      {
        id: 4,
        name: "Warehouse",
        url: "/warehouse",
      },
    ]
  },
  {
    id: 6,
    heading: "Maintenance",
    url: null,
    icon: <BsWrenchAdjustable fontSize={"24px"} />,
    isDropdown: true,
    subMenusList: [
      {
        id: 1,
        name: "Dashboard",
        url: "/dashboard",
      },
      {
        id: 2,
        name: "Issues",
        url: "/issue",
      },
      {
        id: 3,
        name: "Services",
        url: "/services",
      },
      {
        id: 4,
        name: "Work Orders",
        url: "/work-orders",
      }
    ]
  },




  {
    id: 7,
    heading: "Customers",
    url: "/customers",
    icon: customerSidebarIcon,
  },
  // Temporarily hidden from sidebar. Uncomment this block to show Contract again.
  // {
  //   id: 12,
  //   heading: "Contract",
  //   url: "/contract",
  //   icon: financeSidebarIcon,
  // },
  // Temporarily hidden from sidebar. Uncomment this block to show 3PL again.
  // {
  //   id: 8,
  //   heading: "3PL",
  //   url: null,
  //   // Add MdLocalShipping back to the react-icons/md import before uncommenting this icon.
  //   icon: <MdLocalShipping fontSize={"24px"} />,
  //   isDropdown: true,
  //   subMenusList: [
  //     {
  //       id: 1,
  //       name: "Transporter",
  //       url: "/transporters",
  //     },
  //     {
  //       id: 2,
  //       name: "Load Booking",
  //       url: "/3pl/load-booking",
  //     },
  //     {
  //       id: 3,
  //       name: "Quotations",
  //       url: "/3pl/quotations",
  //     },
  //   ]
  // },
  {
    id: 12,
    heading: "Contract",
    url: "/contract",
    icon: contractSidebarIcon,
  },
  {
    id: 8,
    heading: "3PL",
    url: null,
    icon: <MdLocalShipping fontSize={"24px"} />,
    isDropdown: true,
    subMenusList: [
      {
        id: 1,
        name: "Transporter",
        url: "/transporters",
      },
      {
        id: 2,
        name: "Load Booking",
        url: "/3pl/load-booking",
      },
      {
        id: 3,
        name: "Quotations",
        url: "/3pl/quotations",
      },
    ]
  },
  {
    id: 11,
    heading: "Finance",
    url: null,
    icon: financeSidebarIcon,
    isDropdown: true,
    subMenusList: [
      {
        id: 8,
        name: "Dashboard",
        url: "/finance-dashboard",
      },
      // {
      //   id: 1,
      //   name: "Trip Cost Estimation",
      //   url: `/${FinanceSubModules.TripCostEstimation}`,
      // },
      // {
      //   id: 2,
      //   name: "Driver Expense",
      //   url: `/${FinanceSubModules.DriverExpense}`,
      // },
      // {
      //   id: 3,
      //   name: "Driver Payments",
      //   url: `/${FinanceSubModules.DriverPayments}`,
      // },
      {
        id: 4,
        name: "Payroll",
        url: `/${FinanceSubModules.Payroll}`,
      },
      {
        id: 5,
        name: "Invoices",
        url: `/${FinanceSubModules.Invoices}`,
      },
      // {
      //   id: 6,
      //   name: "Financial Reports",
      //   url: `/${FinanceSubModules.FinancialReports}`,
      // },
      {
        id: 9,
        name: "Reports",
        url: "/finance-reports",
      },
      {
        id: 7,
        name: "Settings",
        url: `/${FinanceSubModules.Settings}`,
      },
    ]
  },
  {
    id: 9,
    heading: "Access Management",
    url: "/access-management",
    icon: accessManagementIcon,
  },
  {
    id: 14,
    heading: "Role Management",
    url: "/role-management",
    icon: <FiShield fontSize={"24px"} />,
  },
  // {
  //   id: 13,
  //   heading: "Roles",
  //   url: "/roles",
  //   icon: accessManagementIcon,
  // },
  ...(isSubModuleShow ? [
    {
      id: 10,
      heading: "App Modules",
      url: "/app-modules",
      icon: accessManagementIcon,
    },
  ] : [])

];

export const sideMenuList = baseSideMenuList;


export const customStyles = {
  tableWrapper: { style: { overflow: "visible" } },
  rows: {
    style: {
      fontSize: "14px",
      overflow: "visible"
    },
  },
  headCells: {
    style: {
      fontSize: "14px",
      fontWeight: "400",
      color: "#9C9FC9",
      paddingLeft: "25px",
      overflow: "visible"
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#3D3F5C",
      fontWeight: "400",
      paddingLeft: "25px",
      overflow: "visible"
    },
  },
};

export const slugfy = (value) => {
  return value ? value.toLowerCase().replace(/ /g, '-') : '';
}

export const modules = {
  toolbar: [
    // [{ header: [1, 2, false] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline"],
    [{ align: [] }],
    ["link"],
  ]
};

export const getCurrentUser = () => {
  const userDetails = JSON.parse(localStorage.getItem("fms-maintenance-details"));
  return userDetails || null;
}

export const formatLogAfter = (after, currentUser) => {
  if (!after) return '';
  return after.replace(/\[\[(.*?)\]\]/g, (match, username) => {
    return `<strong>${username}</strong>`;
  });
};

// export function formatDate(dateStr) {
//   if (!dateStr) return '';
//   const date = new Date(dateStr);
//   const options = { month: 'short', day: 'numeric' };
//   const datePart = date.toLocaleDateString(undefined, options);
//   let hours = date.getHours();
//   const minutes = date.getMinutes().toString().padStart(2, '0');
//   const ampm = hours >= 12 ? 'PM' : 'AM';
//   hours = hours % 12;
//   hours = hours ? hours : 12;
//   return `${datePart} at ${hours}:${minutes} ${ampm}`;
// }

// define some light background colors & matching text colors
const bgColors = [
  "#E3F2FD", "#FFF3E0", "#E8F5E9", "#F3E5F5", "#E0F7FA", "#FFFDE7", "#FBE9E7"
];
const textColors = [
  "#1565C0", "#EF6C00", "#2E7D32", "#6A1B9A", "#00838F", "#F9A825", "#D84315"
];

// helper function to pick color based on username (stable random)
export const getColorSet = (str) => {
  if (!str) return { bg: "#e0e0e0", color: "#333" };
  const index = str.charCodeAt(0) % bgColors.length;
  return { bg: bgColors[index], color: textColors[index] };
};

export const timeAgo = (dateInput) => {
  if (!dateInput) return '';
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return '';
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 1) return 'just now';
  if (seconds < 60) return `${seconds} sec ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} day${days > 1 ? 's' : ''} ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months} month${months > 1 ? 's' : ''} ago`;
  const years = Math.floor(days / 365);
  return `${years} year${years > 1 ? 's' : ''} ago`;
};

export const tripInitialValues = {
  // Step 0
  description: "",
  customer: "",
  contractId: "",
  vehicleType: "",
  costCenter: "",
  startDateTime: "",
  expectedEndDateTime: "",
  // Step 1
  stops: [
    {
      location: {
        location_id: "",
        location_point: "",
        location_latitude: "",
        location_longitude: "",
      },
      stopType: "",
      loadType: "",
      product: "",
      productValue: "",
      quantity: "",
    },
    {
      location: {
        location_id: "",
        location_point: "",
        location_latitude: "",
        location_longitude: "",
      },
      stopType: "",
      loadType: "",
      product: "",
      productValue: "",
      quantity: "",
    },
  ],
  // Legacy fields kept for compatibility with other trip screens
  dispatch_location: {
    dispatch_point: "",
    dispatch_latitude: "",
    dispatch_longitude: "",
  },
  decanting_location: {
    decanting_point: "",
    decanting_latitude: "",
    decanting_longitude: "",
  },
  loadType: "",
  product: "",
  quantity: "",
  // Step 2
  firstDriver: "",
  firstDriverContact: "",
  supplementaryDriver: "",
  supplementaryDriverContact: "",
  helper: "",
  helperContact: "",
  // Step 3
  vehicle: "",
  registrationNumber: "",
  openingFuel: "",
  allocatedFuel: "",
  utilized_fuel: "",
  shortage_qty: "",
  allocatedPettyCash: "",
  startOdometer: "",
  uploadedBy: "",
  uploadDate: new Date().toISOString().split("T")[0],
  // Step 4
  billingFrequency: "",
  paymentMethod: "",
  paymentTerms: "",
  bank: "",
  accountTitle: "",
  iban: "",
  status: "New",
  notes: "",
};

export const partInitialValues = {
  // Step 0
  part_name: "",
  company_name: "",
  part_number: "",
  sku: "",
  category: "",
  description: "",

  // Step 1
  material: "",
  weight: "",
  height: "",
  width: "",
  length: "",
  make: "",
  model: "",
  year: "",
  engineCode: "",
  crossReferenceSku: "",
  maxPressure: "",
  maxVoltage: "",
  maxTemperature: "",

  // Step 2
  unitOfMeasurement: "",

  // Step 3
  safetyStockThreshold: "",
  availableStock: "",
  price: "",
  vendor: ""
};

export function getOriginalFileName(s3Path) {
  if (!s3Path) return '';

  const file = s3Path.split('/').pop();

  // UUID pattern
  const uuidRegex =
    /-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

  // If UUID exists → remove it
  if (uuidRegex.test(file)) {
    return file.replace(uuidRegex, '');
  }

  // Old file (no UUID) → return full name
  return file
}

export function getShortFileName(filePath, maxLength = 32) {
  const originalFileName = getOriginalFileName(filePath);
  if (!originalFileName) return '';

  if (originalFileName.length <= maxLength) {
    return originalFileName;
  }

  const extensionIndex = originalFileName.lastIndexOf('.');
  const hasValidExtension = extensionIndex > 0 && extensionIndex < originalFileName.length - 1;
  const extension = hasValidExtension ? originalFileName.slice(extensionIndex) : '';
  const baseName = hasValidExtension ? originalFileName.slice(0, extensionIndex) : originalFileName;

  const reservedLength = extension.length + 3;
  const truncatedBaseLength = Math.max(8, maxLength - reservedLength);

  return `${baseName.slice(0, truncatedBaseLength)}...${extension}`;
}

export const timeLineIcon = (event) => {
  if (event.type === "vehicle_status") {
    if (event.status === "STOP") {
      return images.stopIcon;
    }
    if (event.status === "IDLE") {
      return images.idleIcon;
    }
    if (event.status === "RUNNING") {
      return images.drivingIcon
    }
    if (event.status === "INACTIVE") {
      return images.stopIcon
    }
  }
  else if (event.type === "harsh_acceleration") {
    return images.harshAccelerationIcon
  }
  else if (event.type === "over_speed") {
    return images.overSpeedIcon
  }
  else if (event.type === "harsh_braking") {
    return images.harshBrakingIcon
  }
  else if (event.type === "trip_start") {
    return images.tripStartedIcon
  }
}

export const tripStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    background: 'transparent',
    border: 'none',
    fontSize: '13px',
    marginTop: '0px',
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    boxShadow: 'none',
    minHeight: "28px",
    minWidth: "100%",
    width: "100%",
    '&:hover': {
      border: 'none',
    },
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: '#3D3F5C',
    fontSize: '14px',
    fontWeight: '400',
  }),
  container: (baseStyles) => ({
    ...baseStyles,
    width: "100%",
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    padding: '0',
    paddingLeft: '24px',
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    margin: '0',
    padding: '0',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    padding: '0',
    paddingLeft: "12px",
    color: '#000',
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    fontSize: '13px',
    cursor: state.isDisabled ? "not-allowed" : "pointer",
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    minWidth: "100%",
    width: "100%",
  }),
}

export const formatString = (str) => {
  if (!str) return "";
  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const fuelStationInitialValues = {
  name: "",
  contact: "",
  email: "",
  location_info: {
    station_point: "",
    station_latitude: "",
    station_longitude: ""
  },
  fuel_company_id: "",
  station_image: "",
  station_document: "",
  rates: [
    { fuel_type: "petrol", price: "" },
    { fuel_type: "diesel", price: "" },
    { fuel_type: "high_octane", price: "" }
  ],
  contract_start_at: "",
  contract_end_at: "",
  fuel_rate_at: "",
  notes: ""
};

export const vehicleStatusClass = (status) => {
  if (status === "STOP") {
    return {
      backgroundColor: "#FDF2F2",
      color: "#EF0000",
    };
  }
  if (status === "IDLE") {
    return {
      backgroundColor: "#FFEFDF",
      color: "#F2841B",
    };
  }
  if (status === "RUNNING") {
    return {
      backgroundColor: "#E9FFE2",
      color: "#299900",
    };
  }
  if (status === "INACTIVE") {
    return {
      backgroundColor: "#FDF7CE",
      color: "#D3B800",
    };
  }
};

const normalizeKey = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

const normalizeLookupValue = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "")
    .replace(/[^a-z0-9]/g, "");

const isPresent = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim() !== "";
  return true;
};

const getValueByPaths = (source, paths = []) => {
  if (!source || !paths.length) return undefined;

  for (const path of paths) {
    const segments = String(path)
      .split(".")
      .map((segment) => segment.trim())
      .filter(Boolean);

    let current = source;
    let validPath = true;

    for (const segment of segments) {
      if (current && typeof current === "object" && segment in current) {
        current = current[segment];
      } else {
        validPath = false;
        break;
      }
    }

    if (validPath && isPresent(current)) {
      return current;
    }
  }

  return undefined;
};

export const findCollectionByKeys = (source, candidates = []) => {
  if (!source || typeof source !== "object") return [];

  const normalizedCandidates = candidates.map(normalizeKey).filter(Boolean);
  const queue = [source];
  const visited = new Set();

  while (queue.length) {
    const current = queue.shift();

    if (!current || typeof current !== "object" || visited.has(current)) {
      continue;
    }

    visited.add(current);

    if (Array.isArray(current)) {
      current.forEach((item) => {
        if (item && typeof item === "object") {
          queue.push(item);
        }
      });
      continue;
    }

    for (const [key, value] of Object.entries(current)) {
      const normalizedCollectionKey = normalizeKey(key);

      if (
        Array.isArray(value) &&
        normalizedCandidates.some((candidate) =>
          normalizedCollectionKey.includes(candidate)
        )
      ) {
        return value;
      }

      if (value && typeof value === "object") {
        queue.push(value);
      }
    }
  }

  return [];
};

export const normalizeOptions = (
  source = [],
  { valueKeys = [], labelKeys = [], defaultLabelPrefix = "Option" } = {}
) => {
  if (!Array.isArray(source)) return [];

  const commonValueKeys = [
    "value",
    "id",
    "branch_id",
    "equipment_type_id",
    "manufacturer_id",
    "model_id",
    "vendor_id",
    "vehicle_id",
  ];

  const commonLabelKeys = [
    "label",
    "name",
    "title",
    "branch_name",
    "equipment_type_name",
    "manufacturer_name",
    "model_name",
    "vendor_name",
    "registration_number",
    "registration_no",
    "vehicle_registration_number",
    "code",
  ];

  const seen = new Set();

  return source.reduce((accumulator, item, index) => {
    if (typeof item === "string" || typeof item === "number") {
      const uniqueKey = String(item);
      if (!uniqueKey || seen.has(uniqueKey)) return accumulator;

      seen.add(uniqueKey);
      accumulator.push({ label: String(item), value: item });
      return accumulator;
    }

    if (!item || typeof item !== "object") return accumulator;

    const value = getValueByPaths(item, [...valueKeys, ...commonValueKeys]);
    const label = getValueByPaths(item, [...labelKeys, ...commonLabelKeys]);
    const nextValue = isPresent(value) ? value : label;
    const nextLabel = isPresent(label)
      ? label
      : isPresent(nextValue)
        ? nextValue
        : `${defaultLabelPrefix} ${index + 1}`;

    if (!isPresent(nextValue)) return accumulator;

    const uniqueKey = String(nextValue);
    if (seen.has(uniqueKey)) return accumulator;

    seen.add(uniqueKey);
    accumulator.push({
      ...item,
      label: String(nextLabel),
      value: nextValue,
    });

    return accumulator;
  }, []);
};

export const toText = (value) => String(value ?? "").trim();

export const pickFirstText = (...values) => {
  for (const value of values) {
    const text = toText(value);
    if (text) return text;
  }
  return "";
};

export const normalizeStatusLabel = (status) => {
  const text = toText(status);
  if (!text) return "-";
  return text
    .replace(/_/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
};

export const findOptionByValueOrLabel = (options = [], value = "") =>
  options.find((option) => {
    const optionValue = String(option?.value ?? "");
    const optionLabel = String(option?.label ?? "");
    const targetValue = String(value ?? "");

    return (
      optionValue === targetValue ||
      optionLabel.toLowerCase() === targetValue.toLowerCase() ||
      normalizeLookupValue(optionValue) === normalizeLookupValue(targetValue) ||
      normalizeLookupValue(optionLabel) === normalizeLookupValue(targetValue)
    );
  }) || null;

export const cleanProductName = (name) => {
  if (!name || typeof name !== "string") return "";
  let str = name.trim();
  let prev;
  do {
    prev = str;
    str = str.replace(/\(([^)]+)\)\s*\(\1\)/gi, (match, p1) => `(${p1.trim()})`);
  } while (str !== prev);

  return str.replace(/\s+/g, " ").trim();
};

export { FMCRPermission, FMCRSubModules };
